import React, { useEffect } from "react";
import { RecentTransactionsStyles } from "./styles/RecentTransactions.styles";
import { List, ListItem, Stack, Typography } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import api from "src/store/features/api";
import { CurrencyTransactionRes, PaginatedCTsRes } from "src/store/features/api/generated";
import { dateFormatter } from "src/utils/helpers/DateAndTimeHelpers";
import { useDispatch } from "react-redux";
import { setMostRecentTransaction } from "src/store/features/transactions.slice";
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import { getTicker } from "src/utils/hooks/useGetTicker";
import { useSettingsState } from "src/store/features/settings.slice";

export default function RecentTransactions() {
  const { selectedCurrency: baseCurrency } = useSettingsState();
  const dispatch = useDispatch();
  const classes = RecentTransactionsStyles();
  const symbol = getTicker();
  const { data: recentTransactions, isSuccess } = api.useGetUserCurrencyTransactionsQuery({
    currency: symbol,
  }) as { data: PaginatedCTsRes; isSuccess: boolean };

  useEffect(() => {
    if (isSuccess) {
      // Dispatch the data once available so it's globaly accessible
      if (recentTransactions.data[0]) {
        const recentTransaction = {
          ticker: symbol,
          date: dateFormatter(new Date(recentTransactions.data[0]?.completed ?? 0), false, true),
        };
        dispatch(setMostRecentTransaction(recentTransaction));
      }
    }
  }, [isSuccess]);

  const Item = (props: { transactionData: CurrencyTransactionRes }) => {
    const transactionId = props.transactionData.id;
    const createdDate = props.transactionData.created;
    const transactionType = props.transactionData.type;
    const value = props.transactionData.value;
    const islongerThanSeven = transactionId.length > 7;

    return (
      <Stack direction="row" justifyContent={"space-between"} key={createdDate}>
        <div style={{ margin: " 10px 0px" }}>
          <Typography className={classes.label}>
            {`CT${transactionId.slice(0, 7)}`}
            {islongerThanSeven ? "..." : ""}
          </Typography>
          <Typography className={classes.value} translate="no">
            {formatCurrency(+value, baseCurrency)}
          </Typography>
        </div>
        <div style={{ margin: " 10px 0px", textAlign: "end" }}>
          <Typography className={classes.label}>{transactionType}</Typography>
          <Typography className={classes.value} translate="no">
            {dateFormatter(new Date(createdDate))}
          </Typography>
        </div>
      </Stack>
    );
  };

  const EmptyRecentTransactions = () => {
    return (
      <div>
        <Typography className={classes.title} mb={1}>
          No transactions yet
        </Typography>
        <Typography display="inline" className={classes.noContentLabel}>
          Please deposit money{" "}
        </Typography>
        <NavLink to="/wallets/details" className={classes.here}>
          here
        </NavLink>
        <Typography display="inline" className={classes.noContentLabel}>
          {" "}
          to make a transaction or contact broker.{" "}
        </Typography>
      </div>
    );
  };

  const dataReadyAndContains = recentTransactions && recentTransactions.data.length > 0;

  return (
    <div className={classes.layout}>
      <List>
        {!dataReadyAndContains && <EmptyRecentTransactions />}
        {dataReadyAndContains &&
          recentTransactions.data
            .map((transactionData, iterator) => {
              return (
                <ListItem key={iterator.toString()} sx={{ display: "block", padding: 0 }}>
                  <Item transactionData={transactionData} />
                </ListItem>
              );
            })
            .slice(0, 3)}
      </List>
      <div className={classes.link}>
        <Link to="/transactions/overview" style={{ color: "#002035" }}>
          See All
        </Link>
      </div>
    </div>
  );
}
